(() => {
	const spNavigetion = document.getElementById("sp-navigation");
	if (!spNavigetion) {
		return;
	}

	const siteNavigation = document.getElementById("site-navigation");
	if (!siteNavigation) {
		return;
	}

	const toggleButton = spNavigetion.getElementsByTagName("button")[0];
	if ("undefined" === typeof toggleButton) {
		return;
	}

	const menu = siteNavigation.getElementsByTagName("ul")[0];

	if ("undefined" === typeof menu) {
		toggleButton.style.display = "none";
		return;
	}

	// ボタンクリックでSPナビ .toggled, aria-expanded 切替
	toggleButton.addEventListener("click", () => {
		spNavigetion.classList.toggle("toggled");

		if (toggleButton.getAttribute("aria-expanded") === "true") {
			toggleButton.setAttribute("aria-expanded", "false");
		} else {
			toggleButton.setAttribute("aria-expanded", "true");
		}
	});

	// SPナビ外クリックで .toggled削除, aria-expanded=false
	document.addEventListener("click", (event) => {
		const isClickInside = spNavigetion.contains(event.target);

		if (!isClickInside) {
			spNavigetion.classList.remove("toggled");
			toggleButton.setAttribute("aria-expanded", "false");
		}
	});

	const links = menu.getElementsByTagName("a");
	const linksWithChildren = menu.querySelectorAll(
		".menu-item-has-children > a, .page_item_has_children > a"
	);

	// タッチ操作でのfocus切替
	for (const link of links) {
		link.addEventListener("focus", toggleFocus, true);
		link.addEventListener("blur", toggleFocus, true);
	}

	// 子メニュー有りのfocus切替
	for (const link of linksWithChildren) {
		link.addEventListener("touchstart", toggleFocus, false);
	}

	// .focusの付け外し
	function toggleFocus(event) {
		if (event.type === "focus" || event.type === "blur") {
			let self = this;
			// Move up through the ancestors of the current link until we hit .nav-menu.
			while (!self.classList.contains("nav-menu")) {
				// On li elements toggle the class .focus.
				if ("li" === self.tagName.toLowerCase()) {
					self.classList.toggle("focus");
				}
				self = self.parentNode;
			}
		}

		if (event.type === "touchstart") {
			const menuItem = this.parentNode;
			event.preventDefault();
			for (const link of menuItem.parentNode.children) {
				if (menuItem !== link) {
					link.classList.remove("focus");
				}
			}
			menuItem.classList.toggle("focus");
		}
	}
})();
